import React, { useState } from 'react';
import './Careers.css';

function Careers() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const positions = [
    {
      title: 'UI/UX Designer',
      type: 'Full-time',
      description: 'Design interfaces for our games. Make menus, buttons, and game UI that looks good and works well.',
      requirements: [
        'Can use Figma or similar design tools',
        'Portfolio with UI examples',
        'Knows basic Roblox UI or willing to learn',
        'Available for 20-30 hours per week',
        'Must sign NDA before starting'
      ],
      responsibilities: [
        'Design UI layouts and mockups',
        'Create icon sets and visual assets',
        'Work with developers to implement designs',
        'Iterate based on feedback and testing'
      ],
      benefits: [
        'Revenue share on projects you work on',
        'Flexible remote work',
        'Credit in all games',
        'Portfolio building opportunities'
      ],
      process: 'Send portfolio → Interview → Trial task → NDA signing → Onboarding'
    },
    {
      title: '3D Modeler',
      type: 'Contract',
      description: 'Make 3D models for our Roblox games. Characters, props, buildings - whatever we need for the project.',
      requirements: [
        'Experience with Blender or similar',
        'Can make low-poly models',
        'Show us some of your work',
        'Understand Roblox polygon limits',
        'NDA required for unreleased content'
      ],
      responsibilities: [
        'Model assets based on concept art',
        'Texture and UV unwrap models',
        'Optimize for Roblox performance',
        'Revisions as needed'
      ],
      benefits: [
        'Per-asset payment or revenue share',
        'Work on your own schedule',
        'Keep models in your portfolio after release',
        'Long-term collaboration opportunities'
      ],
      process: 'Submit portfolio → Paid test asset → Contract & NDA → Project work'
    },
    {
      title: 'Programmer',
      type: 'Part-time',
      description: 'Code game features in Lua. Help build the systems that make our games work.',
      requirements: [
        'Knows Lua',
        'Has made stuff in Roblox Studio before',
        'Can figure out bugs',
        '10-20 hours per week availability',
        'Sign NDA for game mechanics and systems'
      ],
      responsibilities: [
        'Write clean, documented code',
        'Implement game mechanics and features',
        'Debug and optimize scripts',
        'Collaborate with the team on Discord'
      ],
      benefits: [
        'Revenue share based on contribution',
        'Remote work',
        'Build your scripting portfolio',
        'Learn from experienced developers'
      ],
      process: 'Code sample review → Technical interview → Test task → NDA & contract → Start'
    },
    {
      title: 'Sound Designer',
      type: 'Contract',
      description: 'Create audio for our games. Sound effects, ambience, whatever makes the game feel right.',
      requirements: [
        'Experience making game audio',
        'Has audio software skills',
        'Portfolio or examples of your work',
        'Can deliver various audio formats',
        'NDA for unreleased game content'
      ],
      responsibilities: [
        'Create sound effects for gameplay',
        'Design ambient audio and music',
        'Edit and master audio files',
        'Revise based on feedback'
      ],
      benefits: [
        'Per-asset payment',
        'Full creative freedom within style guide',
        'Keep audio in portfolio post-release',
        'Potential for ongoing projects'
      ],
      process: 'Portfolio review → Paid sample work → Contract signing → Project briefs'
    }
  ];

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section id="careers" className="careers">
      <div className="container">
        <div className="section-header">
          <h2>Join Our Team</h2>
          <p>We're looking for passionate creators to help build amazing Roblox experiences</p>
          <p className="careers-subtitle">Click any position below to see full details</p>
        </div>
        <div className="careers-list">
          {positions.map((position, index) => (
            <div 
              key={index} 
              className={`career-card ${expandedIndex === index ? 'expanded' : ''}`}
              onClick={() => toggleExpand(index)}
            >
              <div className="career-header">
                <h3>{position.title}</h3>
                <span className="career-type">{position.type}</span>
              </div>
              <p className="career-description">{position.description}</p>
              <div className="expand-indicator">
                {expandedIndex === index ? '−' : '+'}
              </div>
              
              {expandedIndex === index && (
                <div className="career-details">
                  <div className="requirements">
                    <h4>Requirements</h4>
                    <ul>
                      {position.requirements.map((req, i) => (
                        <li key={i}>{req}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="responsibilities">
                    <h4>What You'll Do</h4>
                    <ul>
                      {position.responsibilities.map((resp, i) => (
                        <li key={i}>{resp}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="benefits">
                    <h4>What We Offer</h4>
                    <ul>
                      {position.benefits.map((benefit, i) => (
                        <li key={i}>{benefit}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="process">
                    <h4>Application Process</h4>
                    <p className="process-flow">{position.process}</p>
                  </div>
                  
                  <div className="contact">
                    <h4>Ready to Apply?</h4>
                    <p>Email us at <a href="mailto:careers@meowboxstudios.com">careers@meowboxstudios.com</a></p>
                    <p className="note">Include your portfolio and let us know which position you're interested in</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Careers;
